import { QuizAnswer } from '@/lib/apis/types'

export function isTrue(answer?: QuizAnswer) {
  return answer?.type === 'boolean' && answer.answer === true
}

export function atLeastOneIsSelected(
  answers: Array<string>,
  answer?: QuizAnswer,
) {
  if (answer?.type === 'multiple-choice') {
    const set = new Set(answer.answers)
    for (const answerId of answers) if (set.has(answerId)) return true
  } else if (answer?.type === 'single-choice') {
    return answers.indexOf(answer.answer) !== -1
  }

  return false
}
